import { DOCUMENT_CATEGORIES } from "../Constants/emeterai";

export function getInitials(fullName = "User") {
  var allNames = fullName.trim().split(" ");
  var initials = allNames.reduce((acc, curr, index) => {
    if (index === 0 || index === allNames.length - 1) {
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, "");
  initials = initials.toUpperCase();
  return initials;
}

export const consultationCategoriesLabel = {
  general: "General Tax Consultation",
  "tax-filling": "Tax Filing",
  "tax-file": "Tax Filing",
  spt: "Tax Filing",
  "spt-review": "Tax Filing Review",
  "tax-file-review": "Tax Filing Review",
  finance: "Financial Report",
  "financial-report": "Financial Report",
  "financial-review": "Financial Report Review",
  restitution: "Restitution",
  planning: "Tax Planning",
  review: "Tax Review",
  advisory: "Advisory",
  guidance: "Guidance",
  training: "Training",
  dispute: "Tax Dispute",
  compliance: "Tax Compliance",
  "tp-doc": "Transfer Pricing",
  "tax-invoice": "e-Faktur & e-Bupot",
  "app-troubleshoot": "Tax Applications Troubleshooting",
  study: "Tax Study",
  "tax-clarification": "Tax Clarification",
};

export const consultationCategories = [
  {
    id: "general",
    tag: "general",
    value: "general",
    label: "General Tax Consultation",
  },
  {
    id: "tax-file",
    tag: "tax-file",
    value: "tax-file",
    label: "Tax Filing",
  },
  {
    id: "planning",
    tag: "planning",
    value: "planning",
    label: "Tax Planning",
  },
  {
    id: "review",
    tag: "review",
    value: "review",
    label: "Tax Review",
  },
  {
    id: "tax-clarification",
    tag: "tax-clarification",
    value: "tax-clarification",
    label: "Tax Clarification",
  },
  {
    id: "dispute",
    tag: "dispute",
    value: "dispute",
    label: "Sengketa Pajak",
  },
  {
    id: "compliance",
    tag: "compliance",
    value: "compliance",
    label: "Tax Compliance",
  },
  {
    id: "tp-doc",
    tag: "tp-doc",
    value: "tp-doc",
    label: "Transfer Pricing",
  },
  {
    id: "tax-invoice",
    tag: "tax-invoice",
    value: "tax-invoice",
    label: "e-Faktur & e-Bupot",
  },
  {
    id: "financial-report",
    tag: "financial-report",
    value: "finance",
    label: "Financial Report",
  },
];

export const paymentMethodName = {
  balance: "Saldo",
  bag: "Artha Graha Virtual Account",
  bca: "BCA Virtual Account",
  bni: "BNI Virtual Account",
  bsi: "BSI Virtual Account",
  cimbniaga: "CIMB Niaga Virtual Account",
  cimb: "CIMB Niaga Virtual Account",
  mandiri: "Mandiri Virtual Account",
  bmi: "Muamalat Virtual Account",
  qris: "QRIS",
  akulaku: "Akulaku",
  permata: "Permata Virtual Account",
  permata_snap: "Permata Virtual Account",
  permata_va: "Permata Virtual Account",
  bri: "BRI Virtual Account",
  briva: "BRI Virtual Account",
  bca_klikbca: "KlikBCA",
  bri_epay: "ePay BRI",
  cimb_clicks: "CIMB Clicks",
  danamon_online: "Danamon Online Banking",
  gopay: "GoPay",
  bri_transfer: "BRI Transfer Manual",
  voucher: "Voucher",
  googleplay: "Google Play",
  appstore: "App Store",
  other_va: "Bank Lain",
  bni_midtrans: "BNI Virtual Account",
  bri_midtrans: "BRI Virtual Account",
  cimb_midtrans: "CIMB Niaga Virtual Account",
  mandiri_midtrans: "Mandiri Virtual Account",
  permata_midtrans: "Permata Virtual Account",
};

export const membershipName = {
  FREE: "Regular",
  PREMIUM: "Premium",
  PRIORITY: "Priority",
  CONSULTANT: "Consultant",
};

export const productTypeName = {
  consultation: "Consultation",
  "consultation-extend": "Consultation",
  ebilling: "E-Billing",
  emeterai: "E-Meterai",
  package: "Package",
};

export function pathBuilder(type, id) {
  let path = "";
  switch (type) {
    case "npwp":
      path = `/npwp-services`;
      break;
    case "forum":
      path = `/forum`;
      break;
    case "transaction":
      path = `/transaction`;
      break;
    case "pacakge":
      path = `/subscription`;
      break;
    case "subscription":
      path = `/subscription`;
      break;
    case "chat":
    case "message":
    case "consultation":
    case "consultation-extend":
    case "call":
      // Route through the dynamic resolver (/consultation/:id), which fetches
      // videoProvider and forwards to /chat, /v2/chat, or /v3/chat. The :id is
      // appended by the suffix logic below.
      path = `/consultation`;
      break;
    case "ebilling":
      path = `/ebilling`;
      break;
    case "ebillingForm":
    case "ebillingTemplate":
      path = `/ebilling/create`;
      break;
    case "emeterai":
      path = `/emeterai`;
      break;
    case "emeteraiStamping":
      path = `/emeterai/detail`;
      break;
    case "scheduled-tutoring":
      path = `/consultation`;
      break;
    case "tutoring":
      path = `/tutoring/detail`;
      break;
    case "webinar":
      path = `/webinar`;
      break;
    case "business-service":
      path = `/business-service/order`;
      break;
    case "business_lifecycle":
      path = `/business`;
      break;
    case "pointTransaction":
      path = `/points`;
      break;
    case "businessServiceOrder":
      path = `/business-service/order`;
      break;
    default:
      break;
  }
  if (path === "") {
    path = "/#";
  } else if (
    id &&
    type !== "package" &&
    type !== "subscription" &&
    type !== "ebillingForm" &&
    type !== "ebillingTemplate" &&
    type !== "business-service" &&
    type !== "pointTransaction"
  ) {
    path = `${path}/${id}`;
  } else if (!id) {
    if (path === "/tutoring/detail") {
      path = "tutoring";
    }
  } else if (!id) {
    if (path === "/webinar") {
      path = "webinar";
    }
  }
  return path;
}

/**
 * Resolve the chat route base for a consultation from its videoProvider.
 * Falls back to inference from videoSession / zoomSdkCredentials for legacy
 * rows where videoProvider was never set.
 */
export function getChatBase(consultation) {
  const provider = consultation?.videoProvider;
  if (provider === "realtimekit") return "/v3/chat";
  if (provider === "zoom") return "/v2/chat";
  if (!provider) {
    if (consultation?.videoSession?.provider === "realtimekit")
      return "/v3/chat";
    if (consultation?.zoomSdkCredentials?.sessionName) return "/v2/chat";
  }
  return "/chat";
}

/** Full chat path for a consultation object (provider already known). */
export function chatPath(consultation) {
  return `${getChatBase(consultation)}/${consultation?.id}`;
}

export function currencyFormat(number) {
  let total = Number(number);
  if (isNaN(total)) {
    total = 0;
  }
  // Negatives read as (Rp2.975.000), the same accounting convention
  // formatCurrency uses - not Rp-2.975.000, which put the sign inside the
  // amount and made the two screens disagree over the same figure.
  // Sen, when there are any, print both digits: Rp1.004,10, not Rp1.004,1.
  const abs = Math.round(Math.abs(total) * 100) / 100;
  const formatted = `Rp${abs.toLocaleString("id-ID", {
    minimumFractionDigits: Number.isInteger(abs) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
  return total < 0 ? `(${formatted})` : formatted;
}

export function transformAmplifyError(amplifyErrors = []) {
  if (Array.isArray(amplifyErrors)) {
    return amplifyErrors
      .filter((error) => {
        if (error.message) return true;
        return false;
      })
      .map((error) => {
        return error.message;
      });
  }
  return [];
}

// Fallback for enum values with no label in a masking map. API enums
// (CASH_AND_BANK, DEPRECIATION_AND_AMORTIZATION, otherIncome) must never reach
// the screen raw: separators are dropped and each word is title cased.
// Vowel-less short tokens (PPN, PPH, NPWP) are acronyms and stay uppercase.
export const humanizeEnumLabel = (value, fallback = "") => {
  if (value === null || value === undefined) return fallback;

  const raw = String(value).trim();
  if (!raw) return fallback;

  return raw
    .replace(/[_\-.]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const isAcronym =
        word.length <= 5 && /^[A-Z0-9]+$/.test(word) && !/[AEIOU]/.test(word);

      return isAcronym
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

// Reads a label out of a masking map, humanizing whatever the map has no entry
// for so an unmapped value still renders as regular text.
export const maskedLabel = (labels = {}, value, fallback = "") =>
  labels[value] || humanizeEnumLabel(value, fallback);

// Kept as the historical name for the same masking fallback: every caller
// feeds it an API enum, and lowercasing acronyms (Ppn, Npwp) or gluing camel
// case together (Cashflow) was never what those screens wanted.
export const convertToTitleCase = (str) => humanizeEnumLabel(str);

export const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  let formattedValue = formatter.format(Math.abs(value)).replace(/Rp\s/, "Rp");
  if (value < 0) {
    formattedValue = `(${formattedValue})`;
  }
  return formattedValue;
};

// Withholding tax is remitted in whole rupiah. A decimal reaching the screen
// is float residue from a calculation engine, never an amount anyone pays, so
// the calculators round before formatting. formatCurrency keeps its two
// decimals for everything that genuinely has them.
export const formatMoney = (value) => formatCurrency(Math.round(value || 0));

export const parseCurrencyValue = (val) => {
  if (!val) return 0;
  if (typeof val === "number") return val;
  return (
    parseFloat(
      val
        .toString()
        .replace(/[Rp\s.]/g, "")
        .replace(",", "."),
    ) || 0
  );
};

export function getEmeteraiFileName(key = "", id = "") {
  const path = key.replace("emeterai/", "");
  let file = path.replace(id, "");
  if (file.startsWith("-")) {
    file = file.substring(1);
  }
  return file.trim();
}

export function getAccountingFileName(key = "", id = "") {
  const path = key.replace("accounting/", "");
  let file = path.replace(id, "");
  if (file.startsWith("-")) {
    file = file.substring(1);
  }
  return file.trim();
}

export function generateFileName(path) {
  const parts = path.split("/");
  return parts[parts.length - 1];
}

export function getResourceFileName(key = "", id = "") {
  const path = key.replace("resource/", "");
  let file = path.replace(id, "");
  if (file.startsWith("-")) {
    file = file.substring(1);
  }
  return file.trim();
}

export function getWebinarFileName(key = "") {
  const parts = key.split("/");
  const result = parts[parts.length - 1];

  return result;
}

export function getLabelsByCode(code = "") {
  const labels = DOCUMENT_CATEGORIES.filter((item) => item.value === code)
    .map((item) => item.label)
    .join(", ");

  return labels;
}

export function restampEligible(error = "") {
  if (error === "File tidak dapat diproses. Harap ubah atau perbaiki file.") {
    return false;
  }
  if (error === "Uploaded file was not found.") {
    return false;
  }
  return true;
}

const errorDictionary = {
  "WP Not Found": "Data wajib pajak tidak ditemukan",
};

// Fields whose integer sub-keys are line numbers on the submitted document,
// e.g. {"items": {"0": ["Invalid tax"]}} from the invoice endpoint.
const LINE_INDEXED_FIELDS = new Set(["items", "accounts", "products"]);

// Backend validation strings that have a translation. Anything unlisted passes
// through untouched, which is what every caller already gets today.
const API_ERROR_KEYS = {
  "Invalid tax": "errors.api.invalidTax",
  "Invalid tax account": "errors.api.invalidTaxAccount",
  "Tax type must be PURCHASES for a bill": "errors.api.taxTypePurchases",
  "Tax type must be SALES for an invoice": "errors.api.taxTypeSales",
  "Duplicate tax": "errors.api.duplicateTax",
  "Too many taxes": "errors.api.tooManyTaxes",
  // Arrives under `items` as a plain array rather than keyed by line, because
  // it is a property of the invoice and not of one row.
  "Total pajak dipotong melebihi nilai faktur":
    "errors.api.withholdingExceedsInvoice",
  "Pajak yang dipotong tidak boleh bernilai negatif.":
    "errors.api.withholdingNegative",
  "Invalid period": "errors.api.invalidPeriod",
  "Invalid business data": "errors.api.invalidBusinessData",
  "Invalid export type": "errors.api.invalidExportType",
};

// Walk an `error` payload of arbitrary depth and hand every leaf string to
// `add`, together with the line number it belongs to when one is in scope.
//
// The old version only looked one level down and only kept leaves that were
// strings, so the invoice endpoint's {"items": {"0": ["Invalid tax"]}} — an
// array two levels in — was dropped whole and the user saw nothing.
const collectNestedErrors = (value, fieldKey, add, line = null) => {
  if (value == null) return;
  if (typeof value === "string") {
    add(value, line);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((entry) => collectNestedErrors(entry, fieldKey, add, line));
    return;
  }
  if (typeof value !== "object") return;
  Object.entries(value).forEach(([key, child]) => {
    const isLineIndex =
      /^\d+$/.test(key) && LINE_INDEXED_FIELDS.has(fieldKey);
    collectNestedErrors(
      child,
      isLineIndex ? fieldKey : key,
      add,
      isLineIndex ? Number(key) + 1 : line,
    );
  });
};

// Helper function to parse error response body
export const getApiErrorBody = (error) => {
  if (error?.response?.body) {
    try {
      return typeof error.response.body === "string"
        ? JSON.parse(error.response.body)
        : error.response.body;
    } catch (parseError) {
      return null;
    }
  }
  return null;
};

const toErrorMessageString = (message) => {
  if (typeof message === "string") return message;
  if (typeof message === "number") return String(message);
  if (typeof message?.message === "string") return message.message;
  return "";
};

/**
 * Flatten an error of any shape into a list of display strings.
 *
 * `t` is optional. Without it the return value is exactly what it has always
 * been: raw strings and i18n keys the caller translates itself. Pass it and the
 * messages come back translated and prefixed with the line they belong to —
 * which a caller cannot do afterwards, because a prefixed sentence is no longer
 * a key. Callers that pass `t` must stop translating the result themselves.
 */
export const getErrorMessages = (error, t) => {
  // Use Set to automatically remove duplicates
  const messagesSet = new Set();

  const push = (rawMessage, line = null) => {
    // APIs sometimes send { field, message } objects in these lists. Rendering
    // one as a React child crashes the page, so keep strings only.
    const message = toErrorMessageString(rawMessage);
    if (!message) return;
    // errorDictionary is applied here as well as in the no-`t` return below, so
    // a caller that translates gets the same substitutions. It is idempotent:
    // no dictionary value is itself a dictionary key.
    const mapped =
      API_ERROR_KEYS[message] || errorDictionary[message] || message;
    if (!t) {
      messagesSet.add(mapped);
      return;
    }
    const body = t(mapped);
    messagesSet.add(
      line == null ? body : `${t("errors.line", { line })} ${body}`,
    );
  };

  if (!error) return [];

  if (typeof error === "string") {
    push(error);
  }

  if (error.errors) {
    transformAmplifyError(error.errors).forEach((msg) => push(msg));
  }

  let data = {};
  if (error.response?.data) {
    data = error.response.data;
  }
  if (error.response?.body) {
    data = getApiErrorBody(error);
  }

  if (data?.message) {
    push(data.message);
  }

  if (data?.error) {
    // Strings, arrays and nested validation maps all land here, including the
    // per-line {"items": {"0": [...]}} shape the invoice endpoint returns.
    collectNestedErrors(data.error, null, push);
  }

  if (data?.errors && Array.isArray(data.errors)) {
    data.errors.forEach((msg) => push(msg));
  }

  if (data?.product_errors) {
    Object.values(data.product_errors)
      .flat()
      .forEach((msg) => push(msg));
  }

  if (messagesSet.size === 0 && error.message) {
    push(error.message);
  }

  if (messagesSet.size === 0) {
    messagesSet.add(
      t ? t("errors.generic") : "Terjadi kesalahan, silahkan coba lagi.",
    );
  }

  if (t) return Array.from(messagesSet);

  // Convert messages to localized versions using dictionary
  return Array.from(messagesSet).map(
    (message) => errorDictionary[message] || message,
  );
};

export function hasEmptyCallbackUrlAtEnd(url) {
  // Use URLSearchParams to parse the URL query parameters
  const searchParams = new URL(url).searchParams;

  // Get the value of the callback_url parameter
  const callbackUrlValue = searchParams.get("callback_url");

  // Check if the callbackUrlValue is empty or undefined
  return callbackUrlValue !== null && callbackUrlValue.trim() === "";
}

export const getISODateArray = (startDate, endDate) => {
  const currentDate = new Date(startDate);
  const isoDateArray = [];

  while (currentDate <= endDate) {
    isoDateArray.push(currentDate.toISOString());
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return isoDateArray;
};

export function convertErrorsToString(input, translation = null) {
  if (Array.isArray(input)) {
    if (!translation) {
      return input.join("\n");
    }
    let message = "";
    input.forEach((i) => (message += `${translation(i)}\n`));
    return message;
  } else if (typeof input === "object" && input !== null) {
    if (!translation) {
      return Object.values(input).join("\n");
    }
    let message = "";
    Object.values(input).forEach((i) => (message += `${translation(i)}\n`));
    return message;
  } else {
    // Handle other cases as needed
    return ""; // For simplicity, return an empty string in other cases
  }
}

export function getErrorMessagesString(error) {
  const messages = getErrorMessages(error);
  const errorMessage = convertErrorsToString(messages);
  return errorMessage;
}

export function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

export const generateId = () => Math.random().toString(36).slice(2, 11);

export const formatFileSize = (bytes) => {
  const kb = (bytes / 1024).toFixed(2);
  return `${kb} KB`;
};

export const parseTimeString = (timeString) => {
  if (!timeString) return null;
  const parts = timeString.split(":");
  const hours = parseInt(parts[0], 10) || 0;
  const minutes = parseInt(parts[1], 10) || 0;
  const seconds = parseInt(parts[2], 10) || 0;
  const date = new Date();
  date.setHours(hours, minutes, seconds, 0);
  return date;
};

export const formatTime = (timeString) => {
  if (!timeString) return "-";
  return timeString.substring(0, 5);
};

export function calculateExperience(consultant) {
  if (consultant?.workStartYear) {
    const currentYear = new Date().getFullYear();
    return currentYear - consultant.workStartYear;
  }
  return consultant?.experience || 0;
}

export function generateYearList(startYear = 2005, endYear = null) {
  const currentYear = new Date().getFullYear();
  const finalEndYear = endYear || currentYear - 1;
  const years = [];

  for (let year = finalEndYear; year >= startYear; year -= 1) {
    years.push({
      label: year.toString(),
      value: year,
    });
  }

  return years;
}

export const calculateMonthsDifference = (startDate, endDate) => {
  if (!startDate || !endDate) return 12;

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (end < start) return 0;

  const yearDiff = end.getFullYear() - start.getFullYear();
  const monthDiff = end.getMonth() - start.getMonth();

  let totalMonths = yearDiff * 12 + monthDiff + 1;

  return Math.min(Math.max(totalMonths, 1), 12);
};

export const toCamelCase = (str) => {
  return str
    .toLowerCase()
    .replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};
